module.exports = __webpack_public_path__ + "img/great-success.aca8a4c7.png";